import { useQuery } from '@tanstack/react-query';
import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { api, ApiError } from './api';
import { Shell } from './components/Shell';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { AccountPage } from './pages/AccountPage';
import { TestLabPage } from './pages/TestLabPage';
import { OrdersPage } from './pages/OrdersPage';
import { PerformancePage } from './pages/PerformancePage';
import { StrategyPage } from './pages/StrategyPage';

const MonteCarloPage = lazy(() => import('./pages/MonteCarloPage').then((module) => ({ default: module.MonteCarloPage })));

export function App() {
  const session = useQuery({
    queryKey: ['session'],
    queryFn: () => api<{ username: string; expiresInDays: number }>('/api/auth/session'),
    retry: false
  });

  if (session.isLoading) {
    return (
      <main className="boot-screen">
        <div className="boot-mark"><span>EMA</span><i>ATR</i></div>
        <p>正在校验控制台会话</p>
      </main>
    );
  }

  if (session.error instanceof ApiError && session.error.status === 401) {
    return <LoginPage />;
  }

  if (!session.data) return <LoginPage />;

  return (
    <Shell username={session.data.username}>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/accounts" element={<Navigate to="/" replace />} />
        <Route path="/accounts/:accountId" element={<AccountPage />} />
        <Route path="/test" element={<TestLabPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/performance" element={<PerformancePage />} />
        <Route path="/strategy" element={<StrategyPage />} />
        <Route path="/monte-carlo" element={<Suspense fallback={<div className="empty-state">正在加载模拟工具…</div>}><MonteCarloPage /></Suspense>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}
